﻿import React from "react";
import { observer } from "mobx-react";
import { injectFromApp } from "../../inject";
import { RichToolTipComponent } from "../../rich-tooltip/RichToolTipComponent";
import { ICurrentEnvironmentStore } from "../../environments/CurrentEnvironmentStore";
import { IOtherEnvironmentsStore } from "../../environments/OtherEnvironmentsStore";

interface IEnvironmentSelectorComponentProps {
    currentEnvironmentStore?: ICurrentEnvironmentStore;
    otherEnvironmentsStore?: IOtherEnvironmentsStore;
}

@injectFromApp<IEnvironmentSelectorComponentProps>((stores) => ({
    currentEnvironmentStore: stores.currentEnvironmentStore,
    otherEnvironmentsStore: stores.otherEnvironmentsStore
}))

@observer
export class EnvironmentSelectorComponent extends React.Component<IEnvironmentSelectorComponentProps> {
    render() {
        const { currentEnvironmentStore, otherEnvironmentsStore } = this.props;
        const { currentEnvironment } = currentEnvironmentStore!;
        const { otherEnvironments } = otherEnvironmentsStore!;

        return (
            <div id={ "environment-selector" }>
                <RichToolTipComponent toolTipPosition="left" toolTipResource={ "Environment" } className="selected">
                    { currentEnvironment?.fullName }
                </RichToolTipComponent>
                <div className="other-environments">
                    { otherEnvironments.map((e) => (
                        <div key={ e.id } className={ "other-environment" }>
                            <a href={ e.url }>{ e.fullName }</a>
                        </div>
                    )) }
                </div>
            </div>
        );
    }
}
